export default function random(max, min) {
  return Math.random() * (max - min) + min;
}



/** WEBPACK FOOTER **
 ** ./src/utils/random.js
 **/